/**
 * Minimum properties associated with the `aria-label` property.
 *
 * The aria label type is used to identify components across the variations of the
 * ribbon (MLR vs. SLR).
 */
export type StateWithAriaLabel = {
  root: {
    "aria-label"?: string;
  };
};

/**
 * Process the `state` as a mutable draft state and set the `aria-label` property according
 * to `valueOrDefaultValue`.
 */
export function useAriaLabel<T extends StateWithAriaLabel>(
  state: T,
  value?: string
) {
  if (value !== undefined) {
    state.root["aria-label"] = value;
  }
}
